import { render, staticRenderFns } from "./JournalPay.vue?vue&type=template&id=30ed2bab&"
import script from "./JournalPay.vue?vue&type=script&lang=js&"
export * from "./JournalPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports